import {createApiClient} from "./index";
import {GeneralEmailNotificationDto, NotificationQueryParams} from "types/notifications";

export const notificationApi = {
    async getOne({id, token, type, apiKey}: NotificationQueryParams): Promise<GeneralEmailNotificationDto> {
        const api = createApiClient(apiKey);
        let apiPath = 'email-logs';

        if (type === 'MS_TEAMS') {
            apiPath = 'teams';
        } else if (type === 'SLACK') {
            apiPath = 'slack';
        } else if (type === 'MOBILE_PUSH') {
            apiPath = 'mobile-push';
        }

        const response = await api.get(`/${apiPath}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    },
};
